import './toast.component.scss';

export default ($toast) => {
  'ngInject';

  return {
    restrict: 'E',
    link: function postLink($scope) {
      $scope.$on('$destroy', () => {
        $toast.destroy();
      });
    }
  };
}
